import { Skeleton } from "@mui/material";
import { Breadcrumbs as VoltBreadcrumbs } from "@volt_developers/components";

import { useBreadcrumb } from "./useBreadcrumb";

import type { BreadcrumbItem } from "../../models";

export interface BreadcrumbProps extends Omit<BreadcrumbItem, "id"> {
  isFirst: boolean;
  isLast: boolean;
}

export function Breadcrumb({
  title,
  icon,
  url,
  "data-testid": dataTestId,
  isDisabled: isDisabledByConfig,
  isFirst,
  isLast,
}: BreadcrumbProps) {
  const { isActive, isDisabled } = useBreadcrumb({
    isFirst,
    isLast,
    isDisabledByConfig,
  });
  const titleElement = title ?? <Skeleton width={90} height={24} />;

  if (isActive || isDisabled || !url) {
    return (
      <VoltBreadcrumbs.Text
        sxText={{ margin: "2px 0" }}
        icon={icon}
        data-testid={dataTestId}
        isActive={isActive}
      >
        {titleElement}
      </VoltBreadcrumbs.Text>
    );
  }

  return (
    <VoltBreadcrumbs.Link
      icon={icon}
      to={url}
      data-testid={dataTestId}
      sxLink={{ margin: "2px 0" }}
    >
      {titleElement}
    </VoltBreadcrumbs.Link>
  );
}
